export const enum TICKETS_ROUTES {
  TICKETS_HOME = 'tickets.home',
  ORDER_NEW = 'orders.new',
  RESERVATIONS = 'reservations',
  RESERVATIONS_CONFIRMATION = 'reservations.confirmation',
  ORDER_CONFIRMATION = 'orders.confirmation',
  NOT_FOUND = 'not-found'
}

export const enum MY_ROUTES {
  ORDERS = 'orders',
  RESERVATIONS = 'reservations',
  RESERVATIONS_RESCHEDULE = 'reservations.reschedule',
  RESERVATIONS_RESCHEDULE_CONFIRMATION = 'reservations.reschedule.confirmation',
  ACCOUNT = 'my-account',
  SECURITY = 'security',
  SIGN_IN = 'signIn',
  SIGN_UP = 'signUp',
  VERIFY_ACCOUNT = 'verify-account',
  VERIFY_EMAIL_CHANGE = 'verify-email-change',
  SIGN_OUT = 'signOut',
  RESET_PASSWORD = 'reset-password',
  SEND_RESET_PASSWORD_INSTRUCTIONS = 'send-reset-password-instructions',
  TRIP_CARDS = 'trip-cards',
  TRIP_CARD_BALANCE_HISTORY = 'trip-card-balance-history',
  TRIP_CARD_TOP_UP_HISTORY = 'trip-card-top-up-history',
  ACCOUNT_CREDIT = 'account-credit',
  PAYMENT_METHODS = 'payment-methods',
  NOT_FOUND = 'not-found',
  VERIFY_MAGIC_LINK = 'verify-magic-link',
  VERIFY_IDENTITY_MAGIC_LINK = 'verify-identity-magic-link'
}
